import { Path } from "enums";
import DownloadsModule from "modules/downloads/downloads.module";
import { Route, Switch, Redirect } from "react-router";

const DownloadsPage = () => {
  return (
    <Switch>
      <Route exact path={Path.Downloads} component={DownloadsModule} />
      <Redirect to={Path.Downloads} />
    </Switch>
  );
};

export default DownloadsPage;
